<template>
  <v-sheet
    class="pa-3"
  >
    <v-skeleton-loader
      max-width="300"
      type="list-item-avatar-two-line"
    ></v-skeleton-loader>
  </v-sheet>
</template>

<script>
export default {
    name: "SkeletonForm"
}
</script>